import JSZip from "jszip";
import { saveAs } from "file-saver";

function saveInlay(inlay) {
  let content = '<div class="' + inlay.group + '">';
  let inlay_name = inlay["project-name"];
  let group = inlay.group;
  if (!inlay.name.includes("gt6l")) {
    content += makeContent(inlay.inlay, group);
  } else {
    let btn_index = 0,
      led_idx = 0;

    inlay.inlay.forEach((single_inlay, index) => {
      single_inlay.style.top = inlay.preview.btns[index].style.top;
      for (let btn in single_inlay.btns) {
        single_inlay.btns[btn].style.top =
          inlay.preview.btns[btn_index].style.top;
        btn_index++;
      }
      for (let led in single_inlay.leds) {
        single_inlay.leds[led].style.top =
          inlay.preview.leds[led_idx].style.top;
        led_idx++;
      }
      content += '<div class="gt6l-container">';
      content += makeContent(single_inlay, group);
      content += "</div>";
    });
  }

  const inlay_html =
    '<!DOCTYPE html><html lang="en"><head><meta charset="utf-8">' +
    "<title>" +
    inlay["project-name"] +
    '</title><meta name="description" content=""> ' +
    '<link rel="stylesheet" href="css/styles.css?v=1.0">' +
    '<style>.inlay{border: 2px solid black;background-repeat:no-repeat}.led{ background: #fff;} p {margin: 0 !important; margin-bottom: 5px !important; z-index: 5; white-space: pre-line;}.inlay, .led, .bar_g, .gt-btn, .bar_g_caption,.gt-btn-container{position:absolute}.gt-btn-container{height:inherit; width:inherit; top:0; left:0;} .align-items-end {align-items: flex-end !important}  .align-items-start {align-items: flex-start !important} .align-items-center {align-items: center !important} .justify-content-center {justify-content: center !important} .justify-content-start {justify-content: flex-start !important} .justify-content-end {justify-content: flex-end !important} .d-flex {display: flex !important} .bar_g_caption{font-size:8px;line-height:2.18mm;font-weight:bold}.gt-btn-img{background-repeat:no-repeat; z-index: 5;position:absolute;}body{font-family:Lato, Helvetica, Arial, sans-serif !important; color: #2c3e50}.gt8BlackTriangles{display:none;}.gt8 .gt8BlackTriangles{display:block;overflow:hidden;background-repeat: no-repeat;background-position: bottom;background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOsAAAAPCAYAAAAF3zhBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIFdpbmRvd3MiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NkRERTE5NDU0QzJCMTFFN0JFODJENDQyODJGRkZGRUMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NkRERTE5NDY0QzJCMTFFN0JFODJENDQyODJGRkZGRUMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2RERFMTk0MzRDMkIxMUU3QkU4MkQ0NDI4MkZGRkZFQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2RERFMTk0NDRDMkIxMUU3QkU4MkQ0NDI4MkZGRkZFQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvKl2DoAAAC9SURBVHja7NVLCoRQDETR1P4XXd0NLYj4SaI+HdwLGWYSOEQR4e8oGtkOIsonqbtq/bFGByxYiYZg9QR0Lk5gJXoVVs9xLsUJrESvwOolzDVxAivRo1i9hnJLnMBK9AhWb4HcEyewEg3F6j2MR+IEVqIhWH0EMSNOYCW6FaszCLPiBFaiW7A6C7AiTmAluhSrK/iq4gRWokuwugqvI05gJTqF1R10XXECK1ELawvOGay/zyrOT1TC2vb2EWAAPgJLAVccOR8AAAAASUVORK5CYII=");}' +
    ".gt10d .cutline,.gt2t .cutline{position: absolute;bottom: 6mm;width: 63mm;border-top: 2px dashed #999999;} .cuttext {position: absolute;color: #999999;}.gt8 .cuttext,.gt6l .cuttext {top: 0;} .btn_text {word-break: break-word;}" +
    "</style></head><body>" +
    content +
    '<div style="display:none;" class="gtbackground">' +
    inlay.gtBackground +
    "</div>" +
    "</body></html>";
  // console.log(content);
  return { name: inlay_name, html: inlay_html };
  // }
}

function makeContent(selectedInlay, group) {
  let content = "";
  content += '<div class="inlay ' + group;
  content += selectedInlay.style.horizontal ? " horizontal " : "";
  content += '" style="';

  Object.keys(selectedInlay.style).forEach(
    (key) => (content += key + ":" + selectedInlay.style[key] + ";")
  );
  content +=
    '"><div class="gt8BlackTriangles" style="width: 100%; height: 100%"></div>';
  content += !selectedInlay.style.horizontal
    ? '<div class="cutline"></div><p class="cuttext">Schnittlinie nur für GTS-Serie</p>'
    : "";
  content += "</div>";
  for (let draggable in selectedInlay.draggableTexts) {
    content +=
      '<p class="drag_text" id="' +
      selectedInlay.draggableTexts[draggable].id +
      '" style="z-index:100;position:absolute;top:' +
      selectedInlay.draggableTexts[draggable].top +
      ";left:" +
      selectedInlay.draggableTexts[draggable].left +
      ";";
    Object.keys(selectedInlay.draggableTexts[draggable].style).forEach(
      (key) => {
        content +=
          key + ":" + selectedInlay.draggableTexts[draggable].style[key] + ";";
      }
    );
    content += '">' + selectedInlay.draggableTexts[draggable].content + "</p>";
  }
  for (let btn in selectedInlay.btns) {
    content += '<div class="gt-btn" style="';

    Object.keys(selectedInlay.btns[btn].style).forEach((key) => {
      if (key !== "content" && key !== "image")
        content += key + ":" + selectedInlay.btns[btn].style[key] + ";";
    });
    content +=
      "gradient_1:" +
      selectedInlay.btns[btn].style.gradient.firstColour +
      ";gradient_2:" +
      selectedInlay.btns[btn].style.gradient.secondColour +
      ";";
    content += '">';
    content +=
      '<div class="gt-btn-img" style="background-position:' +
      selectedInlay.btns[btn].style.image["background-position"] +
      ";height: " +
      selectedInlay.btns[btn].style["height"] +
      ";width: " +
      selectedInlay.btns[btn].style["width"] +
      ";background-image: " +
      selectedInlay.btns[btn].style.image["background-image"] +
      ";filter: " +
      selectedInlay.btns[btn].style.image["filter"] +
      ";background-size: " +
      selectedInlay.btns[btn].style.image["background-size"] +
      ';"></div>';
    content +=
      '<div class=" d-flex gt-btn-container ' +
      selectedInlay.btns[btn].content.style["justify-content"] +
      " " +
      selectedInlay.btns[btn].content.style["align-items"] +
      '"><p style="';
    Object.keys(selectedInlay.btns[btn].content.style).forEach((key) => {
      if (key !== "content")
        content +=
          key +
          ":" +
          (selectedInlay.btns[btn].content.style[key]
            ? selectedInlay.btns[btn].content.style[key]
            : "") +
          ";";
    });
    content +=
      '" class="btn_text">' +
      selectedInlay.btns[btn].content.content +
      "</p></div></div>";
  }
  for (let led in selectedInlay.leds) {
    content += '<div class="led" style="';
    Object.keys(selectedInlay.leds[led].style).forEach((key) => {
      content += key + ":" + selectedInlay.leds[led].style[key] + ";";
    });
    content += '"></div>';
  }
  for (let barGLed in selectedInlay.bargraph) {
    content += '<div class="bar_g" style="';
    Object.keys(selectedInlay.bargraph[barGLed].style).forEach((key) => {
      content += key + ":" + selectedInlay.bargraph[barGLed].style[key] + ";";
    });
    content +=
      "display:" +
      (selectedInlay.showBargraph &&
      selectedInlay.selectedBarGType == selectedInlay.bargraph[barGLed].type
        ? "block;"
        : "none;");
    content +=
      '" id="' +
      selectedInlay.bargraph[barGLed].type +
      "_" +
      selectedInlay.bargraph[barGLed].id +
      '"></div>';

    //now add the captions
    content += '<div class="bar_g_caption" style="';
    Object.keys(selectedInlay.bargraph[barGLed].caption.style).forEach(
      (key) => {
        content +=
          key + ":" + selectedInlay.bargraph[barGLed].caption.style[key] + ";";
      }
    );
    selectedInlay.showBargraphCaptions &&
    selectedInlay.selectedBarGType == selectedInlay.bargraph[barGLed].type
      ? (content += "display:block;")
      : (content += "display:none;");
    content += '" id="' + selectedInlay.bargraph[barGLed].id;
    content +=
      '">' + selectedInlay.bargraph[barGLed].caption.content + "</div>";
  }
  return content;
}

function saveAll(inlay) {
  return saveInlay(inlay);
}
function saveSelectedToZip(projectName, selectedInlays) {
  alert("Saving");
  let zip = new JSZip();
  let date = new Date();
  let time = date.getHours() + "_" + date.getMinutes();
  selectedInlays.forEach((inlay) => {
    // console.log(inlay);
    let saved_inlay = saveAll(inlay);
    zip.file(saved_inlay.name + ".html", saved_inlay.html);
  });
  zip.generateAsync({ type: "blob" }).then(function (content) {
    // see FileSaver.js
    saveAs(
      content,
      projectName + "_Auswahl_" + selectedInlays.length + "_" + time + ".zip"
    );
  });
}
export { saveInlay, saveSelectedToZip };
